import clientsHandler from "../../services/Clients";

export default {
    async loadClients({commit, dispatch}, payload) {
        const {data} = await clientsHandler.all(payload);

        commit('SET_CLIENTS', data);
    },
    async storeClient({commit, dispatch}, payload) {
        return clientsHandler.store(payload);
    },
    async updateClient({commit, dispatch}, payload) {
        return clientsHandler.update(payload);
    },
    async removeClient({commit, dispatch}, payload) {
        return clientsHandler.remove(payload);
    },
    async destroyClient({commit, dispatch}, payload) {
        return clientsHandler.destroy(payload);
    },
}
